import ListingCardTemplate from './ListingCardTemplate';

export default ListingCardTemplate;
